/* eslint-disable */
import { TRACKING_TYPES } from '@vfde-fe/ngx-lib/core';

export var config = {
    //TODO: to be moved
    login: {
        name: "login",
        route: "/login"
    },

    //TODO: check this route
    unauthorized: {
        name: "nicht_erlaubt",
        route: "/nicht_erlaubt",
        navigation: {
            topLink: true,
            mobileBtn: false,
            navigationLink: "/meinvodafone/services/",
            mobileBtnLabelKey: "common.buttons.cancel.std-headline"
        }
    },
    //TODO: check this route
    generalError: {
        name: "allgemeiner_fehler",
        route: "/allgemeiner_fehler"
    },
    //TODO: check this route
    logout: {
        targetUrl: "/meinvodafone/meinvf_logout.html",
        timeoutUrl: "/meinvodafone/meinvf_timeout.html",
        tracking: {
            trackingTags: {
                module: "logout",
                siteStructure: ["logout", "manual logout"],
                stepName: "login",
                step: 1,
                status: ["start"]
            }
        }
    },
    topupPayment: {
        name: "payment",
        route: "/payment",
        titleKey: "",
        access: {
            accessLevel: "account"
        },
        chooseAmount: {
            name: "aufladebetrag",
            route: "/payment/aufladebetrag",
            titleKey: "topupPaymentModule.std-headline",
            notifyBeforeUnload: true
        },
        review: {
            name: "uebersicht",
            route: "/payment/uebersicht",
            titleKey: "topupPaymentModule.std-headline",
            notifyBeforeUnload: false,
            tracking: {
                trackingType: "transaction",
                trackingTags: {
                    stopTracking: true,
                    siteStructure: ["self service payment", "start"],
                    siteArea: "mein vodafone payment",
                    type: "self service payment",
                    name: "callya top up",
                    step: "1",
                    stepName: "start",
                    status: ["start"],
                    businessTransactionType: "callya top up",
                    lineOfCustomer: "consumer"
                }
            },
            navigation: {
                topLink: true,
                mobileBtn: true,
                mobileBtnLabelKey: "common.buttons.cancel.std-headline",
                navigationLink: "/meinvodafone/services/teilnehmer/quickcheck?accordion=kostendetails",
                fromMobileApp: false
            }
        },
        confirm: {
            name: "payment/confirm",
            navigation: {
                topLink: true,
                mobileBtn: true,
                mobileBtnLabelKey: "common.buttons.close.std-headline",
                navigationLink: "/meinvodafone/services/teilnehmer/quickcheck?accordion=kostendetails",
                fromMobileApp: false
            }
        },
        navigation: {
            topLink: true,
            mobileBtn: true,
            mobileBtnLabelKey: "common.buttons.cancel.std-headline",
            navigationLink: "/meinvodafone/services/teilnehmer/quickcheck?accordion=kostendetails"
        }
    },
    dunning: {
        name: 'dunning',
        route: '/dunning',
        access: {
            accessLevel: 'contract'
        },
        selfPayment: {
            name: 'direktBezahlen',
            route: '/dunning/direktBezahlen',
            titleKey: 'paymentDunningModule.selfPayment.std-headline',
            access: {
                accessLevel: 'contract',
                contractList: ['kay', 'marie', 'daisy', 'bart', 'della'],
            },
            navigation: {
                topLink: true,
                mobileBtn: true,
                mobileBtnLabelKey: 'common.buttons.cancel.std-headline',
                navigationLink: '/meinvodafone/services/ihre-rechnungen/kontouebersicht',
            },
            fallbackDeeplinking: {
                url: '/meinvodafone/services/ihre-rechnungen/kontouebersicht',
                disableRefresh: false,
            },
            tracking: {
                trackingType: TRACKING_TYPES.TRANSACTION_TRACKING,
                trackingTags: {
                    siteStructure: ['ihre-rechnungen', 'kontouebersicht', 'direkt bezahlen', 'start'],
                    siteArea: 'mein vodafone payment',
                    type: 'self service payment',
                    name: 'dunning direkt bezahlen',
                    step: '1',
                    stepName: 'start',
                    status: ['start'],
                    lineOfCustomer: 'consumer',
                    hasOApplication: {
                        name: 'dunning direkt bezahlen',
                        type: 'myvodafone:transaction',
                    },
                },

            },
        },
        dslPayment: {
            name: 'dsl_direktBezahlen',
            route: '/dunning/dsl_direktBezahlen',
            titleKey: 'paymentDunningModule.dslPayment.std-headline',
            fallbackDeeplinking: {
                url: '/meinvodafone/services/ihre-rechnungen/kontouebersicht',
                disableRefresh: false,
            },
            navigation: {
                topLink: true,
                mobileBtn: true,
                mobileBtnLabelKey: 'common.buttons.close.std-headline',
                navigationLink: '/meinvodafone/services/meinerechnung?accordion=rechnungsubersicht',
            },
            tracking: {
                trackingType: TRACKING_TYPES.TRANSACTION_TRACKING,
                trackingTags: {
                    siteStructure: ['ihre-rechnungen', 'kontouebersicht', 'direkt bezahlen', 'start'],
                    siteArea: 'mein vodafone payment',
                    type: 'self service payment',
                    name: 'dunning direkt bezahlen',
                    step: '1',
                    stepName: 'start',
                    status: ['start'],
                    lineOfCustomer: 'consumer',
                    hasOApplication: {
                        name: 'dunning direkt bezahlen',
                        type: 'myvodafone:transaction',
                    },
                },

            },

    }
}
};
